export default __webpack_public_path__ + "static/media/boletoIconBlue.bc5283e0.svg";